import PropTypes from 'prop-types';

import InstitutionCard from './InstitutionCard';

import './CityInstitutionsList.scss';

const EMPTY_ARRAY = [];

const CityInstitutionsList = ({ institutions = EMPTY_ARRAY, city = '' }) => {
  return (
    <div>
      <h1 className="institutions-cards__title">{city}</h1>
      <div className="institutions-cards__wrapper">
        {institutions.map(institution => (
          <div className="institutions-cards__item" key={institution.ID}>
            <InstitutionCard institution={institution} />
          </div>
        ))}
      </div>
    </div>
  );
};

CityInstitutionsList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  institutions: PropTypes.array,
  city: PropTypes.string
};

export default CityInstitutionsList;
